import { render } from "./AdminPages.vue?vue&type=template&id=11ffc252"
import script from "./AdminPages.vue?vue&type=script&lang=js"
export * from "./AdminPages.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__